import { useState, useEffect, useCallback } from "react";
import debounce from "lodash/debounce";
import { useDebouncedSearchRfiTemplates } from "./queries";

const useRfiSearch = (isFilterSearch, onSearch, resetFilters) => {
  const [searchText, setSearchText] = useState("");
  const [debouncedSearchText, setDebouncedSearchText] = useState("");
  const [showResults, setShowResults] = useState(false);

  const debounceSearch = useCallback(
    debounce((text) => {
      setDebouncedSearchText(text);
    }, 300),
    []
  );

  const handleSearchTextChange = (e) => {
    const text = e.target.value;
    setSearchText(text);

    if (text.length >= 1) {
      debounceSearch(text);
      setShowResults(true);
    } else {
      setShowResults(false);
    }
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!isFilterSearch) {
      try {
        await onSearch(searchText);
      } catch (error) {
        console.error("Error during search:", error);
      }
    }
  };

  const handleResultClick = (result) => {
    setSearchText("");
    setShowResults(false);
    debounceSearch.cancel();
  };

  const handleClearSearch = () => {
    setSearchText("");
    setShowResults(false);
    setDebouncedSearchText("");
    resetFilters();
  };

  useEffect(() => {
    if (searchText?.length < 1) {
      setDebouncedSearchText("");
      setShowResults(false);
    }
  }, [searchText]);

  const {
    data: results,
    isLoading,
    isError,
  } = useDebouncedSearchRfiTemplates(debouncedSearchText);

  return {
    searchText,
    showResults,
    results,
    isLoading,
    isError,
    handleSearchTextChange,
    handleSearch,
    handleResultClick,
    handleClearSearch,
    setSearchText,
  };
};

export default useRfiSearch;
